/*
 * SPDX-FileCopyrightText: 2023 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// eslint-disable-next-line @stencil-community/ban-exported-const-enums
var FlipTileState;
(function (FlipTileState) {
    FlipTileState["None"] = "none";
    FlipTileState["Info"] = "info";
    FlipTileState["Warning"] = "warning";
    FlipTileState["Alarm"] = "alarm";
    FlipTileState["Primary"] = "primary";
})(FlipTileState || (FlipTileState = {}));

export { FlipTileState as F };

//# sourceMappingURL=flip-tile-state-76dd224a.js.map